import { css, type Theme } from "@emotion/react";

export const textCenter = css`
  text-align: center;
`;

export const fullWidth = css`
  width: 100%;
`;

export const constrainedWidth = css`
  max-width: 26rem;
  margin: 0 auto;
`;

export const refreshedSsoStack = (theme: Theme) => css`
  ${constrainedWidth}
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.gap[200]};
  width: 100%;
`;

export const continueWithButton = css`
  margin-top: 1rem;
`;

export const fullWidthButton = css`
  width: 100%;

  label {
    width: 100%;
  }
`;

export const fullWidthButtonWithSpacing = css`
  ${fullWidthButton};
  ${continueWithButton};
`;

export const accountLockedWrapper = css`
  ${constrainedWidth};
  padding-bottom: 2rem;
`;
